// @sonar-ignore
import { Action } from '@reduxjs/toolkit';
import { Observable, timer } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { dialogActions } from '../../actions';

const { dialog } = dialogActions;
/**
 * When a dialog is removed, waits 1 second before showing the next one
 */
const dialogQueueEpic = (action$: Observable<Action>) => action$.pipe(
  filter((action) => dialog?.remove?.match?.(action) ?? (action.type === 'dialog/remove')),
  switchMap(() => timer(1000).pipe(
    map(() => dialog.showNext())
  ))
);

export default dialogQueueEpic;
